export default __webpack_public_path__ + "static/media/bradescoicon.d2a60bdb.svg";